function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.760993902,0 C0.0839939018,0 -0.255006098,0.756 0.224993902,1.2 L4.4629939,6.794 C4.7599939,7.068 5.2399939,7.068 5.5369939,6.794 L9.7759939,1.2 C10.2549939,0.756 9.9159939,0 9.2399939,0 L0.760993902,0 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-5 -6 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/dropdown_down_single.a7481470.svg";
export { SvgComponent as ReactComponent };